import { setActivePaginationLimit, setActivePaginationPage } from "@global-state/pages/admin/myProxies/slice";
import { useGetAllProxiesQuery } from "@RTKQuery/admin/proxy/proxy";
import { Pagination, Select } from "@ui";
import { useAppSelector, useAppDispatch } from "store/hooks";

export function PaginationContainer() {
    const { activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling } = useAppSelector(state => state.myProxiesAdminPage);

    const { data } = useGetAllProxiesQuery({
        page: activePaginationPage,
        limit: activePaginationLimit,
        router_id: activeSearchIdParameter,
        operator: activeOperator,
        phone_number: activeSearchPhoneParameter,
        selling: activeSelling
    });

    const dispatch = useAppDispatch();

    if (data?.count_items) {
        return (
            <div className="grid grid-cols-3 items-center justify-items-center mx-[40px] mb-[20px] max-md:grid-cols-1 max-md:gap-[16px] max-md:mx-[12px]">
                <div></div>
                <Pagination
                    activePage={activePaginationPage - 1}
                    count={Math.ceil((data?.count_items || 0) / activePaginationLimit)}
                    onClickPage={(page) => {
                        dispatch(setActivePaginationPage(page + 1))
                    }}
                />
                <div className="justify-self-end max-sm:justify-self-center">
                    <Select
                        listAlign="top"
                        currentValue={{
                            label: String(activePaginationLimit),
                            value: String(activePaginationLimit)
                        }}
                        onChange={(value) => {
                            dispatch(setActivePaginationLimit(Number(value.value)))
                        }}
                        listValues={[
                            {
                                label: "50",
                                value: "50"
                            },
                            {
                                label: "100",
                                value: "100"
                            },
                            {
                                label: "150",
                                value: "150"
                            },
                            {
                                label: "200",
                                value: "200"
                            }
                        ]}
                    />
                </div>
            </div>
        )
    } else {
        return null;
    }
}